import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "./indexing.css";
import { ApiUrl, BaseUrl } from "../../Admin/API/ApiUrl";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useQuery } from "@tanstack/react-query";

export default function MetricsSlider() {


    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        setIsMounted(true);
    }, []);
    //   const allImages = [...indexing];

    const fetchIndexing = async () => {
        const response = await fetch(`${ApiUrl}/journal-metrics/indexing`);
        const data = await response.json();

        if (!response.ok) {
            throw new Error("Failed to fetch indexing images");
        }

        return data || [];
    };

    const {
        data: indexing = [],
        isLoading,
        isError
    } = useQuery({
        queryKey: ["indexing"],
        queryFn: fetchIndexing,
        staleTime: 10 * 60 * 1000, // cache for 10 mins
    });

    const sliderSettings = {
        dots: false,
        infinite: true,
        speed: 600,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 2500,
        pauseOnHover: true,
        adaptiveHeight: true,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 3 } },
            { breakpoint: 768, settings: { slidesToShow: 2 } },
            { breakpoint: 480, settings: { slidesToShow: 2 } }
        ]
    };
    const openLightbox = (index) => {
        setCurrentIndex(index);
        setLightboxOpen(true);
    };

    const nextImage = () => {
        setCurrentIndex((currentIndex + 1) % indexing.length);
    };

    const prevImage = () => {
        setCurrentIndex((currentIndex - 1 + indexing.length) % indexing.length);
    };

    if (!indexing || indexing.length === 0 || !isMounted || isLoading) {
        return null;
    }

    return (
        <div className="metrics-card">
            <div className="metrics-header">
                <h2 className="metrics-title">Indexing</h2>
                {/* <p className="metrics-subtitle">
                    Explore our impact factors, indexing partners, and current call for papers.
                </p> */}
            </div>
            {isMounted && (
                <Slider {...sliderSettings} className="metrics-slider">
                    {indexing.map((img, index) => (
                        <div key={index} className="metrics-image-wrapper">
                            <img
                                src={`${BaseUrl}/${img.image_path}`}
                                alt=""
                                onClick={() => openLightbox(index)}
                                loading="lazy"
                            />
                        </div>
                    ))}
                </Slider>
            )}


            {/* LIGHTBOX */}
            {lightboxOpen && (
                <div className="metrics-lightbox">

                    <button
                        className="lightbox-close"
                        onClick={() => setLightboxOpen(false)}
                    >
                        ✕
                    </button>

                    <button className="lightbox-prev" onClick={prevImage}>❮</button>

                    <img
                        src={`${BaseUrl}/${indexing[currentIndex].image_path}`}
                        alt=""
                        className="lightbox-image"
                        loading="lazy"
                    />

                    <button className="lightbox-next" onClick={nextImage}>❯</button>

                </div>
            )}

        </div>
    );
}
